import React from "react";

/**
 * Logo quandomiserve.it — supporta due varianti di colore in base allo sfondo:
 *
 *   variant="light" (default) → lancette + slogan BIANCHI. Da usare su sfondi
 *                               scuri (blu homepage, sidebar admin, ecc.).
 *   variant="dark"            → lancette + slogan ARANCIO. Da usare su sfondi
 *                               chiari (bianco, grigio chiaro, admin login).
 *
 *   size    "sm" | "md" | "lg" | "hero" → altezza preset (larghezza automatica)
 *   className / testId → override standard
 */

const SIZE_CLASSES = {
  sm: "h-6 md:h-7",
  md: "h-8 md:h-10",
  lg: "h-12 md:h-14",
  hero: "h-12 sm:h-14 md:h-16 lg:h-20",
};

export const BrandLogo = ({
  size = "md",
  variant = "light",
  className = "",
  testId = "brand-logo",
}) => {
  const sizeClass = SIZE_CLASSES[size] || SIZE_CLASSES.md;
  const src = variant === "dark"
    ? "/logo-quandomiserve-dark.png"
    : "/logo-quandomiserve.png";
  return (
    <img
      src={src}
      alt="quandomiserve.it — Cerca, Confronta, Noleggia"
      className={`${sizeClass} w-auto object-contain select-none ${className}`}
      data-testid={testId}
      draggable={false}
    />
  );
};

export default BrandLogo;
